import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { 
  Container, 
  AppBar, 
  Toolbar, 
  Typography, 
  Box, 
  Tabs, 
  Tab,
  Button,
  IconButton
} from '@mui/material';
import { Logout as LogoutIcon } from '@mui/icons-material';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './components/LoginPage';
import StudentManagement from './pages/StudentManagement';
import ClassManagement from './pages/ClassManagement';
import ScheduleManagement from './pages/ScheduleManagement';
import VacationClassManagement from './pages/VacationClassManagement';
import CertificateManagement from './pages/CertificateManagement';

//임시 테스트 (flask)
import { useEffect } from "react";
import api from "./api";


const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function NavigationTabs() {
  const location = useLocation();
  const { logout } = useAuth();
  
  const getTabValue = () => {
    switch (location.pathname) {
      case '/students':
        return 0;
      case '/classes':
        return 1;
      case '/schedule':
        return 2;
      case '/vacation-class':
        return 3;
      case '/certificates':
        return 4;
      default:
        return 0;
    }
  };

  const handleLogout = async () => {
    await logout();
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Tabs value={getTabValue()} sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tab label="수강생 관리" component={Link} to="/students" />
        <Tab label="수업 관리" component={Link} to="/classes" />
        <Tab label="시간표 관리" component={Link} to="/schedule" />
        <Tab label="방학특강" component={Link} to="/vacation-class" />
        <Tab label="자격증 관리" component={Link} to="/certificates" />
      </Tabs>
      
      <IconButton 
        onClick={handleLogout}
        color="inherit"
        title="로그아웃"
        sx={{ ml: 2 }}
      >
        <LogoutIcon />
      </IconButton>
    </Box>
  );
}

function AppContent() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            이펀 관리 시스템
          </Typography>
        </Toolbar>
      </AppBar>
      
      <Container maxWidth="lg" sx={{ mt: 2 }}>
        <NavigationTabs />
        
        <Box sx={{ mt: 3 }}>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={
              <ProtectedRoute>
                <StudentManagement />
              </ProtectedRoute>
            } />
            <Route path="/students" element={
              <ProtectedRoute>
                <StudentManagement />
              </ProtectedRoute>
            } />
            <Route path="/classes" element={
              <ProtectedRoute>
                <ClassManagement />
              </ProtectedRoute>
            } />
            <Route path="/schedule" element={
              <ProtectedRoute>
                <ScheduleManagement />
              </ProtectedRoute>
            } />
            <Route path="/vacation-class" element={
              <ProtectedRoute>
                <VacationClassManagement />
              </ProtectedRoute>
            } />
            <Route path="/certificates" element={
              <ProtectedRoute>
                <CertificateManagement />
              </ProtectedRoute>
            } />
          </Routes>
        </Box>
      </Container>
    </Box>
  );
}


// Flask API 연결 테스트 (임시)


function TestBackendConnection() {
  useEffect(() => {
    api.get("/api/auth/check-auth")
      .then((res) => {
        console.log("✅ Flask 백엔드 연결 성공:", res.data);
      })
      .catch((err) => {
        console.error("❌ Flask 연결 실패:", err);
      });
  }, []);
  return null; // 화면에 아무것도 렌더링하지 않음
}


// App 함수나 jsx 안에서 컴포넌트 렌더링하려면 아래처럼:
function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
	  
		<AuthProvider>
		<TestBackendConnection />  { /*추가*/}
        <Router>
          <AppContent />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;

